import { render, staticRenderFns } from "./ImageUpload2.vue?vue&type=template&id=4781fd9c"
import script from "./ImageUpload2.vue?vue&type=script&lang=js"
export * from "./ImageUpload2.vue?vue&type=script&lang=js"
import style0 from "./ImageUpload2.vue?vue&type=style&index=0&id=4781fd9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports